var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconImagenology(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2286 16.8477H1.39258V18.4477H18.2286V16.8477Z",
    fill: "#28ADFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33965 11.6397L4.84766 8.14771L11.4796 1.51172L14.9716 5.00371L8.33965 11.6397ZM7.10762 8.14771L8.33965 9.37571L12.7116 5.00371L11.4836 3.7717L7.10762 8.14771Z",
    fill: "#28ADFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0816 17.9605L15.5896 17.3845L16.1256 16.0045C16.4283 15.2186 16.5728 14.3806 16.551 13.5386C16.5292 12.6967 16.3414 11.8673 15.9984 11.0981C15.6554 10.3289 15.164 9.63492 14.5522 9.05601C13.9405 8.47709 13.2205 8.02461 12.4336 7.72451L13.0016 6.22852C13.9857 6.6039 14.886 7.16992 15.6509 7.89412C16.4157 8.61831 17.03 9.48642 17.4585 10.4486C17.8871 11.4108 18.1213 12.4481 18.1479 13.5011C18.1745 14.5541 17.9929 15.6019 17.6136 16.5845L17.0816 17.9605Z",
    fill: "#28ADFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9816 18.1648L12.4896 17.5848L13.4976 14.9928C13.6825 14.5109 13.7615 13.995 13.7294 13.4798C13.6974 12.9647 13.5549 12.4625 13.3118 12.0073C13.0686 11.552 12.7304 11.1544 12.3201 10.8413C11.9097 10.5283 11.4369 10.3071 10.9336 10.1928L11.2816 8.63281C12.0093 8.7973 12.6931 9.11645 13.2866 9.5686C13.88 10.0208 14.3692 10.5953 14.7209 11.2533C15.0727 11.9112 15.2787 12.6372 15.3251 13.3818C15.3714 14.1264 15.257 14.8723 14.9896 15.5688L13.9816 18.1648Z",
    fill: "#28ADFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36184 8.6655L3.23047 9.79688L6.69246 13.2589L7.82383 12.1275L4.36184 8.6655Z",
    fill: "#28ADFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.2408 14.5879H1.46484V16.1879H11.2408V14.5879Z",
    fill: "#28ADFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImagenology);
export default __webpack_public_path__ + "static/media/IconImagenology.8912d71a3dada43412df542f35ea745c.svg";
export { ForwardRef as ReactComponent };